module.exports = __webpack_public_path__ + "media/images/landing/ar/create@2x-4f4a0d789d543103eee4e8fc3df1923b.png";